/**
 * Add-on business rules.
 *
 * Pre-selection logic for the add-ons page. The catalog has no add-on
 * equivalent of the cart-upsell `CADY_AutomaticUpsell` attribute, so
 * these rules live client-side. Cart-upsell auto-selection IS catalog
 * driven via `BookingCartUpsellDto.isAutoSelected` — see
 * `CheckoutSummaryView.autoUpsertCartUpsells`.
 */
import { SessionType, type SessionTypeKey } from '@/stores/sessionType'

import type { AddOnSectionEnriched } from '@/components/AddOnsSelection/types'

/** Session types where all add-ons are pre-selected. */
const ALL_PRESELECT_KEYS: SessionTypeKey[] = [
  SessionType.Legacy,
  SessionType.Standard,
  SessionType.Simple
]

/**
 * Returns add-on section identifiers that should be auto-selected for a session type.
 *
 * Rules:
 * - Legacy / Standard / Simple: all sections pre-selected
 * - All others: no pre-selections
 */
export function getPreSelectedAddOnIds(
  key: SessionTypeKey,
  sections: AddOnSectionEnriched[]
): string[] {
  if (ALL_PRESELECT_KEYS.includes(key)) {
    return sections.map((s) => s.identifier)
  }
  return []
}
